import strings from '../../../globalization';
export const getFormData = () => {
  return [
    {
      elementType: 'text',
      keyboardType: 'default',
      inputType: 'specialName',
      label: strings.masterAdminName,
      placeholder: strings.masterAdminNamePlaceholder,
      required: true,

      stateField: 'name',
      error: ' At Least Four Characters Required',
      stateDefault: '',
      minLength: 4,
      maxLength: 120,
      dependentOnOtherFields: false,
    },
    {
      elementType: 'text',
      keyboardType: 'default',
      inputType: 'hindiName',

      label: strings.masterAdminNameHindi,
      placeholder: strings.masterAdminNameHindiPlaceholder,
      error: ' At Least Two Characters Required',
      required: true,
      stateField: 'name_hindi',
      stateDefault: '',
      minLength: 2,
      maxLength: 120,
      dependentOnOtherFields: false,
    },
  ];
};
